import { SET_COMPONENT_CONFIG } from './types';
import { SET_ANALYTICS_ENABLED } from './types';

// eslint-disable-next-line import/prefer-default-export
export const setComponentConfig = (data) => ({
	type: SET_COMPONENT_CONFIG,
	payload: { ...data, loaded: true },
});

export const setAnalyticsEnabled = (analyticsEnabled) => ({
	type: SET_ANALYTICS_ENABLED,
	payload: analyticsEnabled,
});
